import React from 'react';
import PropTypes from 'prop-types';

import './EventProduct.sass';

import cx from 'classnames';

import ChannelImage from '../../containers/channelUtils/ChannelImage';
import ChannelLink from '../../containers/channelUtils/ChannelLink';
import Tags from '../tags/Tags';
import Pricing from '../pricing/Pricing';
import FormatDate from '../dates/FormatDate';


export default class EventProduct extends React.PureComponent {
  render() {
    const {disabled, presetId, eventId, productVariant, options, occurrence} = this.props;
    const {product} = productVariant;

    return (
      <ChannelLink
        className={cx('event-product', disabled && 'event-product--disabled')}
        to={!disabled && `/service/${product.slug}?variant=${encodeURIComponent(productVariant.code)}&eventPreset=${presetId}&eventId=${eventId}&occurrence=${encodeURIComponent(occurrence)}`}
      >
        <ChannelImage
          className="event-product__image"
          src={product.images[0]}
          width={540}
          height={340}
          alt={product.name}
        />

        <div className="event-product__description">
          {!!(options && options.length) && (
            <div className="event-product__description-tags">
              <Tags tags={options.map(it => it.value)}/>
            </div>
          )}

          <div className="event-product__description-title">
            {product.name}
          </div>
        </div>

        <div className="event-product__info">
          <div className="event-product__info-time">
            <FormatDate
              date={occurrence}
              format="HH:mm"
            />
          </div>
          <div className="event-product__info-price">
            <Pricing value={productVariant.price}/>
          </div>
        </div>
      </ChannelLink>
    );
  }
}



// WEBPACK FOOTER //
// ./components/eventProducts/EventProduct.js